// extracted by mini-css-extract-plugin
export default {"link-btn":"style_link-btn__gn7m1","active-btn":"style_active-btn__9UhZH"};